import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const ratePlanRoutes: RouteObject[] = [
  {
    path: '/rate-plans',
    element: lazyElement(() => import('./List')),
    handle: {
      documentTitle: 'Rate Plans',
      crumb: () => ({ label: 'Rate Plans', to: '/rate-plans' })
    },
  },
];

export default ratePlanRoutes;
